export class ConstantsService {
	public static readonly prices = {
		'small': {
			price: 69,
			backPrice: 14,
			doorPrice: 24,
			shelfPrice: 14,
			drawerPrice: 39,
			crossDivider: 29
		},
		'tall': {
			price: 84,
			backPrice: 19,
			doorPrice: 29,
			shelfPrice: 14,
			drawerPrice: 39,
			crossDivider: 34
		},
		'wide': {
			price: 84,
			backPrice: 19,
			doorPrice: 29,
			shelfPrice: 19,
			drawerPrice: 59,
			crossDivider: 34
		},
		'large': {
			price: 99,
			backPrice: 24,
			doorPrice: 34,
			shelfPrice: 19,
			drawerPrice: 59,
			crossDivider: 39
		},
		'small-corner': {
			price: 69,
		},
		'tall-corner': {
			price: 84,
		},
	};
}
